import { toJson } from '@bufbuild/protobuf';
import { Value, ValueSchema } from '@bufbuild/protobuf/wkt';
import { isNullOrUndefined } from 'utils/utils';

/**
 * A `google.protobuf.Value` is a tagged union (`{ kind: { case, value } }`) once decoded,
 * not the plain JS value it wraps. These helpers unwrap it back into plain JSON.
 */
export const protobufValueToJson = <T>(value?: Value | null): T | null => {
    if (isNullOrUndefined(value)) return null;
    return toJson(ValueSchema, value) as T;
};

/**
 * Unwraps a `map<string, google.protobuf.Value>` field into a plain object.
 */
export const protobufValueMapToJson = <T extends object>(map?: { [key: string]: Value } | null): T => {
    if (isNullOrUndefined(map)) return {} as T;
    return Object.entries(map).reduce((result, [key, value]) => {
        result[key] = protobufValueToJson(value);
        return result;
    }, {}) as T;
};
